export enum NOTIFICATON_TYPES {
  MUTED_BY_HOST = 'mutedByHost',
  UNMUTED_BY_HOST = 'unmutedByHost',
}

export interface RoomNotification {
  ts: number;
  type: NOTIFICATON_TYPES;
}
